"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.extractClientRequestId = extractClientRequestId;
var _request = require("./request");
var _resourceRequest = require("./resource-request");
var _gatewayRequest = require("./gateway-request");
var _merchantRequest = require("./merchant-request");
var _coreConfig = _interopRequireDefault(require("../core-config"));
var _coreCallback = _interopRequireDefault(require("../core-callback"));
var _coreSanitize = _interopRequireDefault(require("../core-sanitize"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/*
 Copyright (c) 2018 Wells Fargo. 333 Market St., San Francisco, CA 94105 All rights reserved.
 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.
 */

/**
 * SDK Core network communication
 *
 * Send Merchant Partner CORS Request
 * Send Gateway CORS Request
 * Send CMS Resource Request
 * Session token handling
 * Standard headers: Pragma & Content-Type
 * Demo mode support
 *
 * context KVPs:
 * - config.get(config.internal).app: stub network component
 * - config.get(config.internal).defaultNetworkTimeout:
 *     default network connection timeout in milliseconds
 * - config.get(config.internal).cmsUrl + config.get(config.internal).demoResponsePath:
 *     demo resource URL
 * - config.get(config.internal).sessionToken: session token
 * - config.get(config.external).demoSwitch[serviceKey]: demo mode switch per backend service
 *
 * options:
 * - opts.success: success callback
 * - opts.failure: failure callback
 * - opts.noInternetConnectionCallback: offline callback
 * - opts.requestTimeoutCallback: request timeout callback
 * - opts.serviceKey: the name of the service, used for logging and demoSwitch lookup
 * - opts.method: HTTP verb e.g. 'GET', 'POST', 'PATCH'
 * - opts.data: request data as a JS object
 *
 * @module core-network
 *
 * @author Nathan Freeling
 * @copyright 2018 Wells Fargo, All rights reserved.
 */

/**
 * Sends AJAX request to a merchant API.
 *
 * @param {Object} response The ajax response object
 * @return {String} the extracted client request id
 */
function extractClientRequestId(response) {
  return _coreSanitize["default"].sanitizeAll(response && response.headers ? response.headers['client-request-id'] || response.headers['Client-Request-Id'] || '' : '');
}

/**
 * Clears the session token from internal context
 */
function clearSessionToken() {
  // wipe the old session token
  if (_coreConfig["default"].get(_coreConfig["default"].internal).sessionToken) {
    _coreCallback["default"].invokeParentCallback(_coreCallback["default"].callbacks.generalLog, {
      message: "SDK cleared session token at:".concat(new Date().toISOString())
    });
    _coreConfig["default"].get(_coreConfig["default"].internal).sessionToken = '';
  }
}
var _default = exports["default"] = {
  sendResourceAjaxRequest: _resourceRequest.sendResourceAjaxRequest,
  sendGatewayAjaxRequest: _gatewayRequest.sendGatewayAjaxRequest,
  sendMerchantAjaxRequest: _merchantRequest.sendMerchantAjaxRequest,
  clearSessionToken: clearSessionToken,
  setDefaultTimeout: _request.setDefaultTimeout,
  setRetryTimeout: _request.setRetryTimeout
};
//# sourceMappingURL=index.js.map